import asyncRequestHandler from 'helpers/functions/AsyncRequestHandler';
import { FunctionDispatch, ThunkResult } from 'redux/types';
import { getPreAuthTransactions } from 'services/API/PreAuthorize';
import { receiveData } from './DataAction';
import { AnyResponse } from 'services/API/common/Fetcher';

export const getList = (company_id: string, data: any = {}): ThunkResult<Promise<AnyResponse>> =>
  asyncRequestHandler(async (dispatch: FunctionDispatch) => {
    const res = await getPreAuthTransactions(company_id, data);
    if (!data.export && res.success) {
      dispatch(receiveData(res, 'preAuthTransactions'));
    }
    return res;
  });
